import React, { useState } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions } from '@mui/material';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import { useKeycloak } from '@react-keycloak/web';
import Config from '../../ckcore/core/Config';

/**
 * AddStaffDialog - Thêm thành viên vào tổ chức (qua Keycloak)
 * Props:
 *   - open (bool): Dialog open/close
 *   - onClose (func): callback đóng dialog
 *   - partnerId (number): ID đối tác hiện tại
 * 
 * Lưu ý:
 *   Gọi POST /dashboard/api/v2/partner/{partnerId}/staff
 *   Body: { "username": "...", "role": "staff|manager|admin" }
 */
export default function AddStaffDialog({ open, onClose, partnerId }) {
  const { keycloak } = useKeycloak();

  const [username, setUsername] = useState('');
  const [role, setRole] = useState('staff');
  const [loading, setLoading] = useState(false);
  const [errorMsg, setErrorMsg] = useState('');
  const [successMsg, setSuccessMsg] = useState('');

  const handleAddStaff = async () => {
    if (!username) {
      setErrorMsg('Vui lòng nhập username/email');
      return;
    }
    setLoading(true);
    setErrorMsg('');
    setSuccessMsg('');

    try {
      const url = `${Config.getServerStaffURL()}/staff`;
      const resp = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${keycloak.token}`
        },
        body: JSON.stringify({ username, role })
      });
      if (resp.ok) {
        setSuccessMsg('Thêm thành viên thành công!');
        // đóng dialog sau 2 giây
        setTimeout(() => {
          onClose();
        }, 2000);
      } else {
        const data = await resp.json();
        setErrorMsg(data.message || 'Lỗi khi thêm thành viên');
      }
    } catch (err) {
      console.error(err);
      setErrorMsg('Lỗi mạng hoặc server');
    }

    setLoading(false);
  };

  const handleClose = () => {
    setErrorMsg('');
    setSuccessMsg('');
    setUsername('');
    setRole('staff');
    onClose();
  };

  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogTitle>Thêm thành viên</DialogTitle>
      <DialogContent dividers>
        {errorMsg && <p style={{ color: 'red' }}>{errorMsg}</p>}
        {successMsg && <p style={{ color: 'green' }}>{successMsg}</p>}

        <TextField
          label="Username/Email"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
          fullWidth
          margin="dense"
          disabled={loading || successMsg}
        />

        <TextField
          label="Role (staff|manager|admin)"
          value={role}
          onChange={(e) => setRole(e.target.value)}
          fullWidth
          margin="dense"
          disabled={loading || successMsg}
        />
      </DialogContent>
      <DialogActions>
        {!successMsg && (
          <Button onClick={handleClose} color="primary">
            Hủy
          </Button>
        )}
        {!successMsg && (
          <Button
            variant="outlined" color="warning"
            onClick={handleAddStaff}
            disabled={loading}
          >
            Thêm
          </Button>
        )}
        {successMsg && (
          <Button onClick={handleClose} color="primary">
            Đóng
          </Button>
        )}
      </DialogActions>
    </Dialog>
  );
}
